import { render, staticRenderFns } from "./SecPledge.vue?vue&type=template&id=584fb77f&scoped=true&"
import script from "./SecPledge.vue?vue&type=script&lang=js&"
export * from "./SecPledge.vue?vue&type=script&lang=js&"
import style0 from "./SecPledge.vue?vue&type=style&index=0&id=584fb77f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584fb77f",
  null
  
)

export default component.exports